const ANDROID_APP_ID = 'com.alamo.mobile';
const ANDROID_APP_PLATFORM = 'play';
const HIDE_SMART_BANNER = 'smart-banner-hidden';

export default {
  init(_, domEl) {
    // On Close Smart Banner Button Click
    const closeBtn = domEl.querySelector('.smart-banner__close-btn');
    closeBtn.addEventListener('click', () => {
      localStorage.setItem('smartBannerClosed', 'true');
      document.body.classList.add(HIDE_SMART_BANNER);
    });

    // On View App Button Click
    const viewBtn = domEl.querySelector('.smart-banner__actions-view');
    viewBtn.addEventListener('click', () => {
      if (window.deferredAndroidAppPrompt) {
        window.deferredAndroidAppPrompt.prompt();
        window.deferredAndroidAppPrompt.userChoice.then((choiceResult) => {
          // if user clicked on Accept Install App, close the banner
          if (choiceResult.outcome === 'accepted') {
            document.body.classList.add(HIDE_SMART_BANNER);
          }
        });
      } else {
        // if there was not window.deferredAndroidAppPrompt but banner was still visible, it means user probably have the app installed
        localStorage.setItem('smartBannerClosed', 'true');
        document.body.classList.add(HIDE_SMART_BANNER);
        window.open(`https://play.google.com/store/apps/details?id=${ANDROID_APP_ID}`, '_blank');
      }
    });

    // Check if Alamo android app is installed on the device
    const checkIfAlamoAppInstalled = async () => {
      const apps = (await navigator.getInstalledRelatedApps?.()) ?? [];
      if (apps.some((app) => app.platform === ANDROID_APP_PLATFORM)) {
        document.body.classList.add(HIDE_SMART_BANNER);
      }
    };

    checkIfAlamoAppInstalled();
  },
};
